import React from 'react';

function HistoryTestData() {
  return (
    <div>
      <h1>History Details</h1>
    </div>
  );
}

export default HistoryTestData;
